import { ApiClient } from '@wrapforce/shared/api-client';
import { getAccessToken, refreshAccessToken } from './supabase';

export const api = new ApiClient({
  baseUrl: import.meta.env.VITE_API_URL as string,
  getAccessToken,
  onUnauthorized: refreshAccessToken,
});
